import { HttpClient,HttpHeaders ,} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { environment } from "../../../environments/environment";
import { VposUserAppView } from 'src/app/models/vpos-user-app-view';
import { catchError, map } from 'rxjs/operators';
import { CommonFunctionService,UserMerchantData } from './../Common/common-function.service';

@Injectable()
export class ChangeTempPasswordService {
  headers: any;
  token: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) { }

  changePassword(data) {
    return this.service.create(environment.changeTempPassword, data);
  }
  isValidOldPassword(EmailUserName, UserType, data) {
    this.GetUserAuthdetails();
    return this.http.get<VposUserAppView>(environment.checkOldPasswordUrl + "?email=" + EmailUserName + "&usertype=" + UserType + "&passwordhash=" + data, { headers: this.headers });
  }


  createPassword(data, keyval) {
    this.GetUserAuthdetails();
    return this.http.post(
      environment.createPassword + "?keyval=" + keyval,
      data, { headers: this.headers }
    );
  }


  isValidMerchantKeyId(data, resellerId) {
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.isValidMerchantKeyIdUrl + '?merchantKeyId=' + data + "&ResellerId=" + resellerId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response)
      ,catchError(this.common.handleError));
  }
  getresellerdatabasedonurl(url) {
    this.GetUserAuthdetails();
    return this.http.get<any>(environment.getresellerdatabasedonurl + "?url=" + url, { headers: this.headers });
  }

  GetUserAuthdetails() {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" + 'IT';
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
}
